<template>
    <div class="progress-bar">
        <div class="bar-body">
            <div class="des">
                <span
                    >已评审{{ countInfo.submitedCount }}人/{{
                        countInfo.totalCount
                    }}人</span
                >
                <span class="more" ref="more" @click.stop="openPopover"
                    >查看</span
                >
            </div>
            <div class="bar">
                <div class="bar_jd" :style="barWidth"></div>
            </div>
        </div>
        <el-popover
            :boxStyle="{ left, bottom, width: 525 }"
            :trgStyle="{ left: '100px' }"
            :visible.sync="visible"
            maxHeight="400px"
        >
            <div class="expert" slot="body">
                <div class="expert_title">
                    <h2>
                        当前评审－{{ countInfo.activityName
                        }}<span>{{ textDes }}</span>
                    </h2>
                </div>
                <div class="expert_body main-scrollbar">
                    <ul>
                        <li
                            v-for="item in items"
                            :key="item.userId"
                            :title="item.userName"
                        >
                            <div class="box">
                                <div class="userimg">
                                    <img src="@/assets/img/13.png" alt="" />
                                </div>
                                <span
                                    :class="
                                        userState(item.flowUserStatus).className
                                    "
                                    >{{
                                        userState(item.flowUserStatus).text
                                    }}</span
                                >
                                <h6>{{ item.userName }}</h6>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </el-popover>
    </div>
</template>
<script>
import { apiGetUserCountInfo, apiGetFlowUserInfos } from "@/server/progress";
import { isNumber } from "lodash";
export default {
    data() {
        return {
            countInfo: { submitedCount: 0, totalCount: 0 },
            visible: false,
            bottom: 0,
            left: 0,
            items: [],
        };
    },
    computed: {
        barWidth() {
            return {
                width:
                    (this.countInfo.submitedCount / this.countInfo.totalCount) *
                        100 +
                    "%",
            };
        },
        userState() {
            return function(t) {
                let text = "",
                    className = "";
                if (t === 0) {
                    text = "评审中";
                    className = "red";
                }
                if (t === 1) {
                    text = "评审完成";
                    className = "green";
                }
                if (t === 2) {
                    text = "表决中";
                    className = "red";
                }
                if (t === 3) {
                    text = "表决完成";
                    className = "green";
                }
                return {
                    text,
                    className,
                };
            };
        },
        textDes() {
            let count =
                this.countInfo.totalCount - this.countInfo.submitedCount;
            if (count <= 0) {
                return "";
            } else {
                return `（还有[${count}]位专家未完成操作，请稍等）`;
            }
        },
    },
    mounted() {
        this.getUserCountInfo();
        // // 添加定时器刷新
    },
    methods: {
        getUserCountInfo() {
            apiGetUserCountInfo({
                prjId: this.$route.query.prjId,
            }).then((res) => {
                this.countInfo = res.data;
                apiGetFlowUserInfos().then((res) => {
                    this.$nextTick(() => {
                        this.items = res.data;
                    });
                });
            });
        },
        openPopover() {
            this.updateData();
        },
        updateData() {
            apiGetUserCountInfo({
                prjId: this.$route.query.prjId,
            }).then((res) => {
                this.countInfo = res.data;
                apiGetFlowUserInfos().then((res) => {
                    this.items = res.data;
                    if (this.visible === true) {
                        return false;
                    }
                    this.$nextTick(() => {
                        const rect = this.$refs.more.getBoundingClientRect();
                        this.bottom =
                            document.body.clientHeight - rect.top + 10;
                        this.left = rect.left - 100;
                        this.visible = true;
                    });
                });
            });
        },
    },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/less/scroll-bar.less";
.progress-bar {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding-bottom: 20px;
    padding-top: 20px;
    background-color: #fff;
    z-index: 10;

    .bar-body {
        padding: 0 20px;

        .des {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 10px;

            span {
                font-size: 12px;
                color: #333;
            }

            .more {
                color: #1965FF;
                cursor: pointer;
            }
        }

        .bar {
            width: 100%;
            height: 4px;
            background-color: #DCE1E6;
            position: relative;
            overflow: hidden;

            &_jd {
                background-color: #1965FF;
                position: absolute;
                width: 0%;
                height: 100%;
                transition: all 0.3s;
            }
        }
    }

    .expert {
        position: relative;

        &_title {
            padding: 0 5px;

            h2 {
                font-size: 14px;
                color: #333;
                border-bottom: 1px solid #DCE1E6;
                padding-bottom: 20px;
                padding-left: 15px;

                span {
                    color: red;
                }
            }
        }

        &_body {
            max-height: 400px;
            overflow-y: scroll;
            padding: 13px 10px;
            ul {
                li {
                    display: inline-block;
                    position: relative;
                    width: 100px;
                    height: 105px;
                    text-align: center;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin-bottom: 7px;
                    overflow: hidden;

                    .box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .userimg {
                            background-color: #DCE1E6;
                            height: 54px;
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: flex-end;

                            img {
                                width: 50px;
                                height: 48px;
                            }
                        }

                        span {
                            width: 100%;
                            height: 26px;
                            line-height: 26px;
                            text-align: center;
                            color: #fff;
                            &.red {
                                background-color: #ff0000;
                            }

                            &.green {
                                background-color: #19b521;
                            }
                        }

                        h6 {
                            color: #333;
                            font-size: 14px;
                            margin-top: 9px;
                            font-weight: 400;
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis; //显示省略符号来代表被修剪的文本
                            white-space: nowrap; //文本不会换行，文本会在在同一行上继续，直到遇到 <br> 标签为止。
                        }
                    }
                }
            }
        }
    }
}
</style>
